// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-drawer-container {
  background: inherit;
  height: 100%;
  overflow: hidden;
}
.mat-drawer-container.hidden {
  display: none;
}

.mat-drawer-content {
  background: inherit;
  height: 100%;
  display: grid;
}
.mat-drawer-content-activity {
  grid-template-rows: auto 1fr;
}
.mat-drawer-content-full {
  grid-template-rows: 1fr;
}

.mat-drawer {
  width: 200px;
  background-color: rgba(0, 0, 0, 0.6);
}
.mat-drawer button {
  width: 100%;
  text-align: left;
}
.mat-drawer button span {
  margin-left: 30px;
}

.mat-toolbar {
  position: sticky;
  display: grid;
  top: 0;
  margin: 0 auto;
  width: 100%;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: auto;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 6px;
  z-index: 1000;
}
.mat-toolbar .left-aligned {
  height: 56px;
  grid-column: 1;
  grid-row: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.mat-toolbar .centered {
  height: 56px;
  grid-column: 1/4;
  grid-row: 1;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}
.mat-toolbar .right-aligned {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-column: 3;
  grid-row: 1;
}

.mat-mdc-unelevated-button {
  border-radius: 0;
}

.mat-mdc-raised-button {
  border-radius: 0;
}

.router-outlet-wrapper-full {
  height: 100vh;
}

.hidden-toolbar .router-outlet-wrapper {
  top: 0px;
}

.hidden-toolbar .mat-toolbar {
  display: none;
}

.loader-container {
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  text-align: center;
}
.loader-container p {
  margin-top: 20px;
  font-weight: bold;
  font-size: 1em;
}
.loader-container img {
  height: 60px;
  width: 60px;
}
.loader-container.hidden {
  display: none;
}

.notification {
  display: inline;
  position: absolute;
  left: 21px;
  top: -2px;
}

@media (max-width: 599px) {
  .router-outlet-wrapper,
  .loader-container {
    top: 56px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAAI;EACI,aAAA;AAER;;AACA;EACI,mBAAA;EACA,YAAA;EACA,aAAA;AAEJ;AADI;EACI,4BAAA;AAGR;AADI;EACI,uBAAA;AAGR;;AAAA;EACI,YAAA;EACA,oCAAA;AAGJ;AAFI;EACI,WAAA;EACA,gBAAA;AAIR;AAHQ;EACI,iBAAA;AAKZ;;AADA;EACI,gBAAA;EACA,aAAA;EACA,MAAA;EACA,cAAA;EACA,WAAA;EACA,oCAAA;EACA,wBAAA;EACA,0CAAA;EACA,aAAA;AAIJ;AAHI;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAKR;AAHI;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AAKR;AAHI;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;AAKR;;AAFA;EACI,gBAAA;AAKJ;;AAHA;EACI,gBAAA;AAMJ;;AAJA;EACI,aAAA;AAOJ;;AALA;EACI,QAAA;AAQJ;;AANA;EACI,aAAA;AASJ;;AAPA;EACI,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;AAUJ;AATI;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AAWR;AATI;EACI,YAAA;EACA,WAAA;AAWR;AATI;EACI,aAAA;AAWR;;AARA;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAWJ;;AATA;EACI;;IAEI,SAAA;EAYN;AACF","sourcesContent":[".mat-drawer-container {\n    background: inherit;\n    height: 100%;\n    overflow: hidden;\n    &.hidden {\n        display: none;\n    }\n}\n.mat-drawer-content {\n    background: inherit;\n    height: 100%;\n    display: grid;\n    &-activity {\n        grid-template-rows: auto 1fr;\n    }\n    &-full {\n        grid-template-rows: 1fr;\n    }\n}\n.mat-drawer {\n    width: 200px;\n    background-color: rgba(0, 0, 0, 0.6);\n    button {\n        width: 100%;\n        text-align: left;\n        span {\n            margin-left: 30px;\n        }\n    }\n}\n.mat-toolbar {\n    position: sticky;\n    display: grid;\n    top: 0;\n    margin: 0 auto;\n    width: 100%;\n    grid-template-columns: auto 1fr auto;\n    grid-template-rows: auto;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 3px 6px;\n    z-index: 1000;\n    .left-aligned {\n        height: 56px;\n        grid-column: 1;\n        grid-row: 1;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n    }\n    .centered {\n        height: 56px;\n        grid-column: 1 / 4;\n        grid-row: 1;\n        display: flex;\n        align-items: center;\n        text-align: center;\n        justify-content: center;\n    }\n    .right-aligned {\n        height: 56px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        grid-column: 3;\n        grid-row: 1;\n    }\n}\n.mat-mdc-unelevated-button {\n    border-radius: 0;\n}\n.mat-mdc-raised-button {\n    border-radius: 0;\n}\n.router-outlet-wrapper-full {\n    height: 100vh;\n}\n.hidden-toolbar .router-outlet-wrapper {\n    top: 0px;\n}\n.hidden-toolbar .mat-toolbar {\n    display: none;\n}\n.loader-container {\n    top: 64px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 998;\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    text-align: center;\n    p {\n        margin-top: 20px;\n        font-weight: bold;\n        font-size: 1em;\n    }\n    img {\n        height: 60px;\n        width: 60px;\n    }\n    &.hidden {\n        display: none;\n    }\n}\n.notification {\n    display: inline;\n    position: absolute;\n    left: 21px;\n    top: -2px;\n}\n@media (max-width: 599px) {\n    .router-outlet-wrapper,\n    .loader-container {\n        top: 56px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
